import { Animated } from "react-native"

/**
 * @deprecated Use react-native-reanimation instead
 */
export function startAnimation(
  animation: Animated.CompositeAnimation,
  finishedCallback?: () => void,
): () => void {
  animation.start(
    finishedCallback
      ? ({ finished }) => {
          if (finished) {
            finishedCallback()
          }
        }
      : undefined,
  )
  return () => {
    animation.stop()
  }
}
